// extracted by mini-css-extract-plugin
export default {"container":"BehindPermission_container__z6vFR"};